<template>
  <div :class="['pretty p-smooth p-default']">
    <input
      type="checkbox"
      v-bind="$attrs"
      v-bind:value="value"
      v-bind:checked="isChecked"
      @change="change"
    />
    <div :class="['state p-primary space-x-1 ', $attrs.disabled ? 'bg-gray-200' : '']">
      <label>
        <slot />
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script>
import BaseIcon from './_base-icon.vue'

export default {
  components: {
    BaseIcon,
  },
  inheritAttrs: false,
  props: {
    value: {},
    checked: {},
  },
  model: {
    prop: 'checked',
    event: 'input',
  },
  methods: {
    change() {
      if (Array.isArray(this.checked)) {
        let checked = [].concat(this.checked)
        if (checked.includes(this.value)) {
          checked.splice(checked.indexOf(this.value), 1)
        } else {
          checked.push(this.value)
        }
        this.$emit('input', checked)
      } else {
        this.$emit('input', !this.checked)
      }
    },
  },
  computed: {
    hasLabel() {
      return typeof this.$attrs.label !== 'undefined'
    },
    label() {
      return typeof this.$attrs.label === 'undefined'
        ? ''
        : this.$t(`mygwf.components.Label.${this.$attrs.label}`)
    },
    hasSvg() {
      return typeof this.$attrs.svg !== 'undefined'
    },
    isChecked() {
      if (typeof this.checked === 'boolean') {
        return this.checked
      }
      if (Array.isArray(this.checked)) {
        return this.checked.indexOf(this.value) > -1
      }
      return this.checked === this.value
    },
  },
}
</script>
